<template>
  <div class="modal fade" tabindex="-1" :data-bs-backdrop="backdrop" ref="modal">
    <div class="modal-dialog" :class="customClass">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              v-if="backdrop === true"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </slot>
        </div>
        <div class="modal-body">
          <slot name="form" :disabled="disabled" />
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <slot name="actions" />
            <button
              v-if="!disabled"
              type="button"
              class="btn"
              :class="danger ? 'btn-danger' : 'btn-primary'"
              @click.prevent="handleSave"
            >
              {{ saveText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal as bootstrapModal } from 'bootstrap';

export default {
    name: 'BaseModal',
    data() {
        return {
            modal: null,
        }
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        onSave: {
            type: Function,
            default: () => {},
        },
        saveText: {
            type: String,
            default: 'Save changes',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        danger: {
            type: Boolean,
            default: false,
        },
        backdrop: {
            type: Boolean,
            default: true,
        },
        customClass: {
            type: String,
            default: '',
        },
        automaticClose: {
            type: Boolean,
            default: true,
        },
    },
    created() {
        if (this.$refs.modal) {
            this.modal = new bootstrapModal(this.$refs.modal);
        }
    },
    beforeUnmount() {
        this.modal?.dispose();
    }, 
    expose: ['show', 'hide'],

    methods: {
        show() {
            if (!this.modal && this.$refs.modal) {
                this.modal = new bootstrapModal(this.$refs.modal);
            }
            this.modal.show();
        },
        hide() {
            if (!this.modal || !this.$refs.modal) {
                return Promise.resolve();
            }

            const modalElement = this.$refs.modal;
            if (!modalElement.classList.contains('show')) {
                this.modal.hide();
                return Promise.resolve();
            }

            return new Promise((resolve) => {
                modalElement.addEventListener('hidden.bs.modal', resolve, { once: true });
                this.modal.hide();
            });
        },
        handleSave() {
            this.onSave();
            if(this.automaticClose) {
              this.hide();
            }
        },
    },
}
</script>
